jQuery(window).load(function() {
	
	jQuery('body').addClass('loaded');
			
});


jQuery( document ).ready(function() {
	
	if( jQuery('body').hasClass('page-template-template-our-educational-consultants') ) {
		
		search_consultants();
		
	}

});

jQuery('.student-result button').click(function(){
	
	var intent = jQuery( this ).attr( 'class' );
	var send = jQuery( '.consultant-banner' ).data( 'consultant' );
	
	var recieve = jQuery( this ).parent().parent().data( 'consultant' );
	var student = jQuery( this ).parent().parent().data( 'student' );
	
	console.log('ran');
	
	file_request( intent, send, recieve, student, '' );
	
	//parent - student ID, primary consultant ID
	//request-access
	
});

jQuery('a[href^="#"]').on('click',function (e) {
        // e.preventDefault();

    var target = this.hash,
    $target = jQuery(target);

    jQuery('html, body').stop().animate({
    
    	'scrollTop': $target.offset().top-200
        
    }, 900, 'swing', function () {
		
		window.location.hash = target;
 
 	});

});

jQuery('.__PrivateStripeElement iframe').click(function(){
	
	jQuery(this).css('display', 'block');
	
});